<!-- <template>
    <Popup ref="popup" :animation="'scale'">
        <div id="scratch-container">
            <canvas id="scratch-canvas"></canvas>
            <img src="../../assets/images/scratch-card-images/scratch_card_open_m.png" alt="Scratch Card"
                id="prize-image">
            <img src="../../assets/images/scratch-card-images/gold_coin.png" alt="Coin" id="coin-image">
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue';
export default {
    methods: {
        show() {
            this.$refs.popup.show();
            this.$nextTick(() => {
                this.initScratchCard();
            });
        },
        hide() {
            this.$refs.popup.hide();
        },
        initScratchCard() {
            const canvas = document.getElementById('scratch-canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();
            const coinImage = document.getElementById('coin-image');
            let totalPixels = 0;
            let scratchedPixels = 0;
            let isScratching = false;

            img.src = require('../../assets/images/scratch-card-images/scratch_card_close_m.png');
            img.onload = () => {

                canvas.width = img.width;
                canvas.height = img.height;


                ctx.drawImage(img, 0, 0, img.width, img.height);

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                totalPixels = imageData.data.length / 4;
            };


            canvas.addEventListener('mousedown', startScratch);
            canvas.addEventListener('mousemove', scratch);
            canvas.addEventListener('mouseup', endScratch);
            canvas.addEventListener('touchstart', startScratch);
            canvas.addEventListener('touchmove', scratch);
            canvas.addEventListener('touchend', endScratch);

            function startScratch(e) {
                isScratching = true;
                scratch(e);
            }

            function scratch(e) {
                if (!isScratching) return;

                const rect = canvas.getBoundingClientRect();
                let x, y;

                if (e.touches) {
                    x = e.touches[0].clientX - rect.left;
                    y = e.touches[0].clientY - rect.top;
                } else {
                    x = e.clientX - rect.left;
                    y = e.clientY - rect.top;
                }

                ctx.globalCompositeOperation = 'destination-out';
                ctx.lineWidth = 80;
                ctx.lineCap = 'round';
                ctx.strokeStyle = 'rgba(0,0,0,1)';
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x, y);
                ctx.stroke();

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                scratchedPixels = 0;

                for (let i = 0; i < imageData.data.length; i += 4) {
                    if (imageData.data[i + 3] === 0) {
                        scratchedPixels++;
                    }
                }

                const scratchedPercentage = (scratchedPixels / totalPixels) * 100;

                if (scratchedPercentage > 40) {
                    revealPrize();
                }
            }

            function endScratch() {
                isScratching = false;
            }

            const revealPrize = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                setTimeout(() => {

                    coinImage.style.display = 'block';
                    coinImage.classList.add('coin-animation');


                    setTimeout(() => {
                        this.hide();
                    }, 2000);
                }, 800);
            };
        }
    },
    components: {
        Popup,
    }
};

</script>

<style scoped>
#scratch-container {
    position: relative;
    width: 100%;
    max-width: 440px;
    height: 440px;
    margin: auto;
}

#scratch-canvas {
    width: 100%;
    height: auto;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
}

#prize-image {
    display: block;
    width: 100%;
    height: auto;
}

#coin-image {
    display: none;
    position: absolute;
    top: 75%;
    left: 50%;
    width: 115px;
    height: 115px;
    border-radius: 100%;
    transform: translate(-50%, -50%);
    z-index: 10;

}


@keyframes spin-zoom-up {
    0% {
        transform: translate(-50%, -50%) scale(0.5) rotate(0deg);
        opacity: 1;
    }

    70% {
        transform: translate(-50%, -50%) scale(1.5) rotate(360deg);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -150%) scale(1.5) rotate(360deg);
        opacity: 0;
    }
}

.coin-animation {
    animation: spin-zoom-up 2s ease-in-out forwards;
}


</style> -->
<!-- 
<template>
    <Popup ref="popup" :animation="'scale'">
        <div id="scratch-container">
            <canvas id="scratch-canvas"></canvas>
            <img alt="Scratch Card" id="prize-image" @load="adjustCanvasSize">
            <img :src="coinImageSrc" alt="Coin" id="coin-image" v-if="isRevealed">
            <div :id="getAmountId()" :class="{ 'visible': isRevealed }" v-if="isRevealed">
                {{ this._global.extra.bonus }}
            </div>
            <button id="collect-btn" v-if="isScratched" @click="collectBonus">COLLECT</button>
            <BonusAnimation ref="bonusAnimation" />

        </div>
    </Popup>
</template>
<script>
import Popup from '../Popup.vue';
import api from '../../network/api.js';
import BonusAnimation from '../animations/BonusAnimation.vue';

export default {
    data() {
        return {
            isScratched: false,
            isRevealed: false,
            coinImageSrc: '',
            showAnimation: false,
            base64Image: ''
        }
    },
    methods: {
        show() {
            this.$refs.popup.show();
            this.$nextTick(() => {
                this.initScratchCard();
            });
        },
        hide() {
            this.$refs.popup.hide();
        },
        collectBonus() {
            //console.log("Collect button clicked");
            this.showBonusAnimation();
        },

        getAmountId(){
            return this._global.extra.bonus_type === 'manual' ? 'coin-amount' : 'chip-amount';
        },

        showBonusAnimation() {
            if (this.$refs.bonusAnimation) {
                const isMobile = window.innerWidth <= 768;

                const from = isMobile ? { x: 150, y: 250 } : { x: 300, y: 200 };
                const to = {
                    coins: isMobile ? { x: 100, y: -200 } : { x: 250, y: -250 },
                    chips: isMobile ? { x: 300, y: -200 } : { x: 600, y: -250 }
                };


                this.$refs.bonusAnimation.show();

                this.$refs.bonusAnimation.startAnimation(
                    this._global.extra.bonus_type === 'manual',
                    this._global.extra.bonus_type === 'chips',
                    false,
                    from,
                    to,
                    () => {
                        //console.log('Bonus animation complete');
                        this.collectPrize();
                        this.hide();
                    }
                );
            } else {
                console.error("BonusAnimation component not found in $refs");
            }
        },


        collectPrize() {

            api.collectFreeBonus(this._global.user.userID, this._global.extra.bonus_id).then((resp) => {
                //alert("Congratulations!! You collected the bonus successfully");
                //console.log('Bonus collected:', resp);
                this.$emit('bonus-collected', resp);
            }).catch((error) => {
                console.error('Error collecting bonus:', error);
            });
        },
        showLottieAnimation() {
            this.showAnimation = true;

            // Hide animation and popup after 4 seconds
            // setTimeout(() => {
            //     this.showAnimation = false;
            //     // this.hide();
            // }, 4000); // 4000ms = 4 seconds
        },
        adjustCanvasSize() {
            const prizeImage = document.getElementById('prize-image');
            const canvas = document.getElementById('scratch-canvas');

            canvas.width = prizeImage.clientWidth;
            canvas.height = prizeImage.clientHeight;
        },
       
        // collectPrize(){
        //     api.collectFreeBonus(this._global.user.userID, this._global.extra.bonus_id).then((resp) => {
        //         alert("Congratulation!! You collected bonus successfully");
        //         console.log('Bonus collected:', resp);
        //     }).catch((error) => {
        //         console.error('Error collecting bonus:', error);
        //     });
        // },
        async initScratchCard() {
            const isMobile = window.innerWidth <= 768;
            let totalPixels = 0;
            let scratchedPixels = 0;
            let isScratching = false;

            let isRevealed = false;
            const canvas = document.getElementById('scratch-canvas');
            const ctx = canvas.getContext('2d', { willReadFrequently: true });
            const img = new Image();
            //img.crossOrigin = "Anonymous";

            const prizeImgSrc = isMobile
                ? this._global.assetsRoot + '/scratch_card_open_m.png'
                : this._global.assetsRoot + '/scratch_card_open.png';

            var hostname = window.location.hostname;
            //console.log(hostname);

            /*const scratchImgSrc = isMobile
                ? '/web_store/images/scratch_card_close_m.png'
                : '/web_store/images/scratch_card_close.png';*/

            const scratchImgSrc = isMobile
                        ? this._global.assetsRoot + '/scratch_card_close_m.png'
                        : this._global.assetsRoot + '/scratch_card_close.png';

            //let url = this._global.assetsRoot + '/scratch_card_close_m.png';
            let url = scratchImgSrc;
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                const reader = new FileReader();

                reader.onloadend = () => {
                    const prizeImage = document.getElementById('prize-image');
                    prizeImage.src = prizeImgSrc;

                    prizeImage.onload = () => {
                        this.base64Image = reader.result; 
                        //console.log(this.base64Image);

                        img.src = this.base64Image;
                        img.onload = () => {
                            this.drawScratchImage(ctx, img, canvas);

                            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                            totalPixels = imageData.data.length / 4;

                            this.isRevealed = true;
                        };
                    }

                    this.coinImageSrc = this._global.extra.bonus_type === 'manual'
                        ? this._global.assetsRoot + '/coins_6.png'
                        : this._global.assetsRoot + '/chips_6.png';


                    canvas.addEventListener('mousedown', startScratch);
                    canvas.addEventListener('mousemove', scratch);
                    canvas.addEventListener('mouseup', endScratch);
                    canvas.addEventListener('touchstart', startScratch, { passive: false });
                    canvas.addEventListener('touchmove', scratch, { passive: false });
                    canvas.addEventListener('touchend', endScratch, { passive: false });
                    canvas.addEventListener('pointerdown', startScratch, { passive: false });
                    canvas.addEventListener('pointermove', scratch, { passive: false });
                    canvas.addEventListener('pointerup', endScratch, { passive: false });
                };

                reader.readAsDataURL(blob); // Convert blob to base64
            } catch (error) {
                console.error("Error converting image to Base64: ", error);
            }

            const revealPrize = () => {
                if (!isRevealed) {
                    isRevealed = true;
                    this.isScratched = true;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    const coinImage = document.getElementById('coin-image');
                    coinImage.style.display = 'block';
                    coinImage.classList.add('coin-animation');
                }
            };

            function startScratch(e) {
                e.preventDefault();
                isScratching = true;
                scratch(e);
            }

            function scratch(e) {
                e.preventDefault(); 
                if (!isScratching) return;

                const rect = canvas.getBoundingClientRect();
                let x, y;

                if (e.touches) {
                    x = e.touches[0].clientX - rect.left;
                    y = e.touches[0].clientY - rect.top;
                } else {
                    x = e.clientX - rect.left;
                    y = e.clientY - rect.top;
                }

                ctx.globalCompositeOperation = 'destination-out';
                // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                // ctx.globalCompositeOperation = isSafari ? 'xor' : 'destination-out';
                ctx.lineWidth = 80;
                ctx.lineCap = 'round';
                ctx.strokeStyle = 'rgba(0,0,0,1)';
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x, y);
                ctx.stroke();

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                scratchedPixels = 0;

                for (let i = 0; i < imageData.data.length; i += 4) {
                    if (imageData.data[i + 3] === 0) {
                        scratchedPixels++;
                    }
                }

                const scratchedPercentage = (scratchedPixels / totalPixels) * 100;

                if (scratchedPercentage > 50) {
                    revealPrize();

                }
            }

            function endScratch(e) {
                e.preventDefault(); 
                isScratching = false;
            }
        },
        drawScratchImage(ctx, img, canvas) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        }
    },
    components: {
        Popup,
        BonusAnimation
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
#scratch-canvas {
    touch-action: manipulation;
    -webkit-user-select: none;
}
// #scratch-canvas {
//     touch-action: none;
// }
#scratch-container {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: auto;
    padding: 0;
    z-index: 10;
}


@media (max-width: 768px) {
    #scratch-container {
        max-width: 80%;
        margin: 0 auto;
    }

    #scratch-canvas,
    #prize-image {
        width: 80%;
        height: auto;
    }

    #coin-amount, #chip-amount {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        font-size: 40px;
        font-weight: 900;
        z-index: 1;
    }
    
    #coin-amount{
        color: #ffd700;
    }

    #chip-amount{
        color: #0fcc0f;
    }
}

#scratch-canvas {
    width: 100%;
    height: auto;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
}

#prize-image {
    display: block;
    width: 100%;
    height: auto;
}

#coin-image {
    position: absolute;
    top: 43%;
    left: 50%;
    width: 90px;
    height: 90px;
    border-radius: 100%;
    transform: translate(-50%, -50%) scale(1);
    z-index: 1;
    
}

#coin-image.coin-animation {
    animation: pop-out-grow 1.5s ease forwards;
}

@keyframes pop-out-grow {
    0% {
        transform: translate(-50%, -50%) scale(0.5);
        opacity: 0;
    }

    60% {
        transform: translate(-50%, -50%) scale(2.5);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1.5);
        opacity: 1;
    }
}

#coin-amount, #chip-amount {
    position: absolute;
    top: 62%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    font-size: 40px;
    font-weight: 900;
    z-index: 1;
    text-shadow:
        2px 0px 0px #803e17,
        -2px 0px 0px #803e17,
        0px 2px 0px #803e17,
        0px -2px 0px #803e17,
        2px 2px 0px #803e17,
        -2px 2px 0px #803e17,
        2px -2px 0px #803e17,
        -2px -2px 0px #803e17;
}

#coin-amount{
    color: #ffd700;
}

#chip-amount{
    color: #0fcc0f;
}

#coin-amount.visible, #chip-amount.visible {
    display: block;
    animation: pop-out-grow 1.5s ease forwards;
}

@keyframes pop-out-amount {
    0% {
        transform: translate(-50%, -50%) scale(0.5);
        opacity: 0;
    }

    60% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1.5);
        opacity: 1;
    }
}


#bonus-image {
    display: none;
    position: absolute;
    top: 65%;
    left: 50%;
    width: 80px;
    height: 80px;
    border-radius: 100%;
    transform: translate(-50%, -50%);
    z-index: 10;
}

#collect-btn {
    margin-top: 20px;
    background-image: url($assetRoot + "/collect_button.png");
    background-size: cover;
    width: 180px;
    height: 60px;
    color: white;
    border-radius: 10px;
    font-size: 25px;
    font-weight: 900;
    text-shadow: 2px 0 #282827, -2px 0 #282827, 0 2px #282827, 0 -2px #282827,
        1px 1px #282827, -1px -1px #282827, 1px -1px #282827, -1px 1px #282827;
    border: none;
    cursor: pointer;
}



#collect-button .collect-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: white;
    font-weight: bold;
}

#collect-button.visible {
    display: block;
}
</style> -->

<template>
  <Popup ref="popup" :animation="'scale'">
    <div id="scratch-container">
      <div v-if="loaderVisible" class="loader">Loading...</div>

      <svg
        v-show="!loaderVisible"
        id="scratch-svg"
        @mousedown="startScratch"
        @mousemove="scratch"
        @mouseup="endScratch"
        @touchstart="startScratch"
        @touchmove="scratch"
        @touchend="endScratch"
      >
        <defs>
          <mask id="scratch-mask">
            <rect width="100%" height="100%" fill="white"></rect>
          </mask>
        </defs>
        <image
          id="scratch-close-image"
          :href="scratchImgSrc"
          width="100%"
          height="100%"
          mask="url(#scratch-mask)"
        />
      </svg>

      <img alt="Scratch Card" id="prize-image" @load="handleImageLoad" />
      <img :src="coinImageSrc" alt="Coin" id="coin-image" v-if="isRevealed" />

      <div
        :id="getAmountId()"
        :class="{ visible: isRevealed }"
        v-if="isRevealed"
      >
        {{ this._global.extra.bonus }}
      </div>

      <!-- Place collect button outside the image -->
      <button id="collect-btn" v-if="isScratched" @click="collectBonus">
        COLLECT
      </button>

      <BonusAnimation ref="bonusAnimation" />
    </div>
  </Popup>
</template>

<script>
import Popup from "../Popup.vue";
import api from "../../network/api.js";
import BonusAnimation from "../animations/BonusAnimation.vue";

export default {
  data() {
    return {
      isScratched: false,
      isRevealed: false,
      loaderVisible: true,
      coinImageSrc: "",
      base64Image: "",
      scratchImgSrc: "",
    };
  },
  methods: {
    show() {
      this.$refs.popup.show();
      this.$nextTick(() => {
        this.initScratchCard();
      });
    },
    hide() {
      this.$refs.popup.hide();
    },
    collectBonus() {
      this.showBonusAnimation();
    },
    getAmountId() {
      return this._global.extra.bonus_type === "manual"
        ? "coin-amount"
        : "chip-amount";
    },
    showBonusAnimation() {
      if (this.$refs.bonusAnimation) {
        const isMobile = window.innerWidth <= 768;
        const from = isMobile ? { x: 150, y: 250 } : { x: 300, y: 200 };
        const to = {
          coins: isMobile ? { x: 100, y: -200 } : { x: 250, y: -250 },
          chips: isMobile ? { x: 300, y: -200 } : { x: 600, y: -250 },
        };

        this.$refs.bonusAnimation.show();
        this.$refs.bonusAnimation.startAnimation(
          this._global.extra.bonus_type === "manual",
          this._global.extra.bonus_type === "chips",
          false,
          from,
          to,
          () => {
            this.collectPrize();
            this.hide();
          }
        );
      } else {
        console.error("BonusAnimation component not found in $refs");
      }
    },
    collectPrize() {
      api
        .collectFreeBonus(this._global.user.userID, this._global.extra.bonus_id)
        .then((resp) => {
          this.$emit("bonus-collected", resp);
        })
        .catch((error) => {
          console.error("Error collecting bonus:", error);
        });
    },
    adjustSvgSize() {
      const prizeImage = document.getElementById("prize-image");
      const svg = document.getElementById("scratch-svg");
      svg.setAttribute("width", prizeImage.clientWidth);
      svg.setAttribute("height", prizeImage.clientHeight);
    },
    async initScratchCard() {
      const isMobile = window.innerWidth <= 768;

      const prizeImgSrc = isMobile
        ? this._global.assetsRoot + "/scratch_card_open_m.png"
        : this._global.assetsRoot + "/scratch_card_open.png";

        this.scratchImgSrc = isMobile
                ? this._global.assetsRoot + "/scratch_card_close_m.png"
                : this._global.assetsRoot + "/scratch_card_close.png";

        const closeImage = document.getElementById('scratch-close-image')
        closeImage.src = this.scratchImgSrc;

        closeImage.onload = () => {
            const prizeImage = document.getElementById('prize-image');
            prizeImage.src = prizeImgSrc;

            prizeImage.onload = () => {                
                this.isRevealed = true;
            }
        }

      //document.getElementById("prize-image").src = prizeImgSrc;
      this.coinImageSrc =
        this._global.extra.bonus_type === "manual"
          ? this._global.assetsRoot + "/coins_6.png"
          : this._global.assetsRoot + "/chips_6.png";
    },
    handleImageLoad() {
      this.loaderVisible = false;
      this.adjustSvgSize();
    },
    startScratch(e) {
      e.preventDefault();
      this.isScratching = true;
      this.scratch(e);
    },
    scratch(e) {
      e.preventDefault();
      if (!this.isScratching) return;

      const svg = document.getElementById("scratch-svg");
      const rect = svg.getBoundingClientRect();
      let x, y;

      if (e.touches) {
        x = e.touches[0].clientX - rect.left;
        y = e.touches[0].clientY - rect.top;
      } else {
        x = e.clientX - rect.left;
        y = e.clientY - rect.top;
      }

      const circle = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );
      circle.setAttribute("cx", x);
      circle.setAttribute("cy", y);
      circle.setAttribute("r", "40");
      circle.setAttribute("fill", "black");
      document.getElementById("scratch-mask").appendChild(circle);

      this.checkScratchCompletion(svg);
    },
    endScratch(e) {
      e.preventDefault();
      this.isScratching = false;
    },
    checkScratchCompletion(svg) {
      const totalArea = svg.clientWidth * svg.clientHeight;
      const scratchedArea =
        document.getElementById("scratch-mask").children.length *
        Math.PI *
        20 *
        20;
      const scratchedPercentage = (scratchedArea / totalArea) * 100;

      if (scratchedPercentage > 80 && !this.isScratched) {
        this.isRevealed = true;
        this.isScratched = true;
        document.getElementById("scratch-mask").innerHTML = "";
        this.revealPrize();
      }
    },
    revealPrize() {
      if (this.isRevealed) {
        const coinImage = document.getElementById("coin-image");
        const amountElement = document.getElementById(this.getAmountId());

        this.$nextTick(() => {
          coinImage.classList.add("coin-animation");
          amountElement.classList.add("amount-animation"); // Use a unique class here
        });
      }
    },
  },
  components: {
    Popup,
    BonusAnimation,
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #00b7ff;
  z-index: 10;
}
#scratch-canvas {
  touch-action: none;
}
#scratch-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: auto;
  padding: 0;
  z-index: 10;
}

@media (max-width: 768px) {
  #scratch-container {
    max-width: 80%;
    margin: 0 auto;
  }

  #scratch-canvas,
  #prize-image {
    width: 80%;
    height: auto;
  }

  #coin-amount,
  #chip-amount {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    font-size: 40px;
    font-weight: 900;
    z-index: 1;
  }

  #coin-amount {
    color: #ffd700;
  }

  #chip-amount {
    color: #0fcc0f;
  }
}

#scratch-canvas {
  width: 100%;
  height: auto;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

#prize-image {
  display: block;
  width: 100%;
  height: auto;
}

#coin-image {
  position: absolute;
  top: 43%;
  left: 50%;
  width: 90px;
  height: 90px;
  border-radius: 100%;
  transform: translate(-50%, -50%) scale(1);
  z-index: 1;
}

#coin-image.coin-animation {
  animation: pop-out-grow 1.5s ease forwards;
}

@keyframes pop-out-grow {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }

  60% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 1;
  }
}

#coin-amount,
#chip-amount {
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  font-size: 40px;
  font-weight: 900;
  z-index: 1;
  text-shadow: 2px 0px 0px #803e17, -2px 0px 0px #803e17, 0px 2px 0px #803e17,
    0px -2px 0px #803e17, 2px 2px 0px #803e17, -2px 2px 0px #803e17,
    2px -2px 0px #803e17, -2px -2px 0px #803e17;
}

#coin-amount {
  color: #ffd700;
}

#chip-amount {
  color: #0fcc0f;
}

#coin-amount.visible,
#chip-amount.visible {
  display: block;
  animation: pop-out-grow 1.5s ease forwards;
}

@keyframes pop-out-amount {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }

  60% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 1;
  }
}

#bonus-image {
  display: none;
  position: absolute;
  top: 65%;
  left: 50%;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

#scratch-svg {
  width: 100%;
  height: auto;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

#collect-btn {
  margin-top: 20px;
  background-image: url($assetRoot+"/collect_button.png");
  background-size: cover;
  width: 180px;
  height: 60px;
  color: white;
  border-radius: 10px;
  font-size: 25px;
  font-weight: 900;
  text-shadow: 2px 0 #282827, -2px 0 #282827, 0 2px #282827, 0 -2px #282827,
    1px 1px #282827, -1px -1px #282827, 1px -1px #282827, -1px 1px #282827;
  border: none;
  cursor: pointer;
}

#collect-button .collect-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: white;
  font-weight: bold;
}

#collect-button.visible {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Scratch.vue